import React, { createContext, useContext, useState } from 'react';

import { CompanySearchRequest } from '../../../../generated/model/companySearchRequest';

type SearchContextProps = {
  searchRequest: CompanySearchRequest | null;
  setSearchRequest: React.Dispatch<React.SetStateAction<CompanySearchRequest | null>>;
};

const SearchContext = createContext<SearchContextProps | undefined>(undefined);

type SearchProviderProps = { children: React.ReactNode };

export const SearchContextProvider = ({ children }: SearchProviderProps) => {
  const [searchRequest, setSearchRequest] = useState<CompanySearchRequest | null>(null);
  return (
    <SearchContext.Provider value={{ searchRequest, setSearchRequest }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchState = () => {
  const context = useContext(SearchContext);

  if (context === undefined) {
    throw new Error('SearchState must be used within a SearchProvider');
  }

  return context;
};
